import classnames from 'classnames';

import { ConversationDetailsLayout } from 'components/conversation/conversationDetails/conversationDetailsLayout';

import styles from '../conversationDetails.module.scss';

type NewMessageIndicatorProps = {
  newMessageCount?: number;
  layout: ConversationDetailsLayout;
};

export const NewMessageIndicator = ({
  newMessageCount,
  layout,
}: NewMessageIndicatorProps): JSX.Element => {
  return (
    <div
      className={classnames({
        [styles.newMessages]: true,
        [styles.newMessagesShow]: !!newMessageCount,
        [styles.newMessagesCollapsed]:
          layout === ConversationDetailsLayout.SidebarCollapsed,
      })}
    >
      {newMessageCount}
    </div>
  );
};
